import { forwardRef } from "react"
import { classNames } from "../../utils/helpers"
import { BoxProps } from "../Box"

export interface TextProps extends Omit<BoxProps, "as"> {
  /** specify a different Tag to be used instead of as if you want to get styles based on the as prop but render a different Tag  */
  component?: "p" | "span" | "strong"
  variant?: keyof typeof TEXT_VARIANTS
  as?: "p" | "span" | "strong"
}

const TEXT_CLASSES: { [key: string]: string } = {
  p: "fluid-lg md:fluid-lg",
}
const TEXT_VARIANTS: { [key: string]: string } = {
  label: "text-sm",
  "body-copy": "text-lg",
  "extra-small": "fluid-sm md:fluid-base",
  small: "fluid-base md:fluid-lg",
  medium: "fluid-md md:fluid-md",
  large: "fluid-base sm:fluid-lg md:fluid-xl",
  "extra-large": "fluid-xl md:fluid-2xl",
}

const Text = forwardRef<HTMLParagraphElement, TextProps>(
  ({ as = "p", component, variant, className, children }, ref) => {
    const Tag = component || as
    const styles = variant
      ? TEXT_VARIANTS[variant]
      : typeof Tag === "string"
      ? TEXT_CLASSES[Tag]
      : TEXT_CLASSES.p

    return (
      <Tag ref={ref} className={classNames(styles, className)}>
        {children}
      </Tag>
    )
  }
)

export default Text
